import { useTranslation } from 'react-i18next';
import { useActionBatch } from '../../api/action/action.hooks';
import {
  LightSetBrightnesssBatchChannel,
  SwitchLightOnOffBatchChannel,
  SwitchLightSetOnTimeBatchChannel,
  TypeOfActionType,
} from '../../api/action/action.types';
import { LightToggleValueInternal } from '../../../../data-access/gql-types/graphql';
import { ChannelType } from '../../types';
import { toastInfo } from '../../../../utils/toast';

export const useLightAction = (channels: ChannelType[]) => {
  const { t } = useTranslation('action');
  const actionBatch = useActionBatch();

  const handleControlsOn = (value: string) => {
    if (!channels.length) {
      toastInfo({ content: t('trigger.validationErrors.deviceNotFound') });
      return;
    }

    actionBatch.mutate({
      controls: channels.map((channel) => ({
        deviceId: channel.deviceId,
        channelId: channel.id,
        value: value === LightToggleValueInternal.On,
        $type: TypeOfActionType.BatchLightToggleOnOffRequest,
      })) as SwitchLightOnOffBatchChannel[],
    });
  };

  const handleSetOnTime = (value: number) => {
    if (!channels.length) {
      toastInfo({ content: t('trigger.validationErrors.deviceNotFound') });
      return;
    }

    actionBatch.mutate({
      controls: channels.map((channel) => ({
        deviceId: channel.deviceId,
        channelId: channel.id,
        timeInMilliseconds: value,
        $type: TypeOfActionType.BatchLightSetOnTimeRequest,
      })) as SwitchLightSetOnTimeBatchChannel[],
    });
  };

  const handleSetBrightness = (value: number) => {
    if (!channels.length) {
      toastInfo({ content: t('trigger.validationErrors.deviceNotFound') });
      return;
    }

    actionBatch.mutate({
      controls: channels.map((channel) => ({
        deviceId: channel.deviceId,
        channelId: channel.id,
        brightness: value,
        $type: TypeOfActionType.BatchLightSetBrightnessRequest,
      })) as LightSetBrightnesssBatchChannel[],
    });
  };

  return {
    handleControlsOn,
    handleSetOnTime,
    handleSetBrightness,
  };
};
